











import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCRadio',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  setup(props, { emit }) {
    const onChange = () => {
      emit('on-change', props.value);
    };
    return {
      onChange,
    };
  },
});
